import Vue from 'vue'

Vue.filter('moneyFormat', function (value) {
  if (!value) return 0
  if (typeof value == "string") value = parseFloat(value)
  return value.toLocaleString('de-DE');
});